export const MirageApplicationTypes = {
    buildingcontrol: "buildingcontrol",
    landcharges: "landcharges",
    publicportal: "publicportal",
    planningmanagement: "planningmanagement",
    prePublicPortalWestLindsay: "prePublicPortalWestLindsay",
    streetnamingandnumbering: "streetnamingandnumbering",
    streetNamingAndNumberingPublicPortal: "streetNamingAndNumberingPublicPortal",
    treepreservationorder: "treepreservationorder",
    regulatoryservices: "regulatoryservices",
    enforcementpublicportal: "enforcementpublicportal",
} as const;

export const MirageApplicationPrefixes: Record<IMirageApplications, string> = {
    buildingcontrol: "Bc",
    landcharges: "Lc",
    publicportal: "Pp",
    planningmanagement: "Pm",
    prePublicPortalWestLindsay: "ppWl",
    streetnamingandnumbering: "Snn",
    streetNamingAndNumberingPublicPortal: "snnPp",
    regulatoryservices: "Eha",
    treepreservationorder: "Tpo",
    enforcementpublicportal: "EnfPpo",
};

export const MirageInternalApplicationTypes = {
    buildingcontrol: MirageApplicationTypes.buildingcontrol,
    landcharges: MirageApplicationTypes.landcharges,
    planningmanagement: MirageApplicationTypes.planningmanagement,
    streetnamingandnumbering: MirageApplicationTypes.streetnamingandnumbering,
    regulatoryservices: MirageApplicationTypes.regulatoryservices,
    treepreservationorder: MirageApplicationTypes.treepreservationorder,
} as const;

export type IMirageApplications = typeof MirageApplicationTypes[keyof typeof MirageApplicationTypes];
export type MirageInternalApplication = typeof MirageInternalApplicationTypes[keyof typeof MirageInternalApplicationTypes];
